// extracted by mini-css-extract-plugin
export default {"zoomModal":"I2-z"};